import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Admin_Parivartan_Create_Regions,
  Admin_Parivartan_Get_States,
} from "../../../../constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import toast from "react-hot-toast";

const AddRegionModal = ({ isOpen, onClose }) => {
  const [state, setState] = useState({ stateName: "", stateId: "" });
  const [stateList, setStateList] = useState([]);
  const [form, setForm] = useState({ StateId: "", RegionName: "" });

  const getAllStates = async () => {
    try {
      const response = await axios.get(`${Admin_Parivartan_Get_States}`);
      setStateList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, [isOpen]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      StateId: form.StateId,
      RegionName: form.RegionName,
    };

    try {
      const res = await axios.post(Admin_Parivartan_Create_Regions, payload);
      console.log("Response:", res);
      if (res.data.success) {
        toast.success("Region Created Successfully.");
        onClose();
        handleReset();
      } else{
        toast.error(res.data.message || 'Failed to create region');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || 'Something went wrong';
      toast.error(message);
    }
  };

  const handleReset = () => {
    setForm({ StateId: "", RegionName: "" });
  }

  return (
    <div>
      <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Region
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <FormControl fullWidth>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                label="State"
                value={form.StateId}
                onChange={(e) => handleChange("StateId", e.target.value)}
              >
                <MenuItem value="">
                  <em>Select State</em>
                </MenuItem>
                {stateList.map((st) => (
                  <MenuItem key={st.StateId} value={st.StateId}>
                    {st.StateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Region"
                value={form.RegionName}
                onChange={(e) => handleChange("RegionName", e.target.value)}
                variant="outlined"
                size="small"
              />
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddRegionModal;
